import Vue from 'vue';
import {_axios} from '@/plugins/axios';
import App from '@/App.vue';
import router from '@/plugins/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import UIcon from './plugins/unistra/UIcon.vue';
import Vuelidate from 'vuelidate';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import Cas, {installOptions as CasAuthenticationOptions} from '@vue-unistra/cas-authentication';

import VueMatomo from 'vue-matomo';

import '@/plugins/pwa/swInitialization';

import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import 'dayjs/locale/fr.js';
import {getLocale} from '@/plugins/getLocale';

dayjs().format();
dayjs.extend(isToday);
dayjs.extend(localizedFormat);
dayjs.extend(isSameOrAfter);
dayjs.locale(getLocale());

Vue.config.productionTip = false;

Vue.component('u-icon', UIcon);

const casOptions: CasAuthenticationOptions = {
    axios: _axios,
    router,
    options: {
        appIsAllAuth: true,
        authCasLogoutUrl: '/auth/cas/logout',
        jwtServerUrl: process.env.VUE_APP_JWT_URL,
    },
};

if (process.env.VUE_APP_CAS_URL) {
    // @ts-ignore
    casOptions.options.serverCAS = process.env.VUE_APP_CAS_URL;
}

Vue.use(Cas, casOptions);

if (process.env.NODE_ENV === 'production') {
    if (process.env.VUE_APP_MATOMO_SERVER && process.env.VUE_APP_MATOMO_SITE_ID) {
        const MatomoOptions = {
            router,
            host: process.env.VUE_APP_MATOMO_SERVER,
            siteId: process.env.VUE_APP_MATOMO_SITE_ID,
            trackerFileName: 'm',
            debug: process.env.VUE_APP_MATOMO_DEBUG,
        };
        Vue.use(VueMatomo, MatomoOptions);
    }

    Sentry.init({
        dsn: 'https://c5028d60b350493aa901b8e0a10c305b@sentry.app.unistra.fr/17',
        environment: process.env.VUE_APP_DEPLOYEMENT_TAG_SENTRY,
        integrations: [new Integrations.Vue({Vue, attachProps: true})],
    });
}

Vue.use(Vuelidate);

Vue.config.devtools = ['dev', 'test', 'preprod'].includes(process.env.VUE_APP_DEPLOYEMENT_TAG_SENTRY);

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
}).$mount('#app');
